import {runInAction} from "mobx";
import {DataCollectionOptions} from "@cuba-platform/react/dist/data/Collection";
import {DataCollectionStore, getCubaREST} from "@cuba-platform/react";
import {EntitiesWithCount, SerializedEntity} from "@cuba-platform/rest/dist-node/model";

export class DataCollectionStoreWithAfterLoadFilter<T> extends DataCollectionStore<T> {

  afterLoadFilter: (result: Array<SerializedEntity<T>>) => Array<SerializedEntity<T>>;

  constructor(entityName: string, afterLoadFilter: (result: Array<SerializedEntity<T>>) => Array<SerializedEntity<T>>,
              opts: DataCollectionOptions) {
    super(entityName, !!opts.trackChanges);
    this.afterLoadFilter = afterLoadFilter;

    if (opts.view) {
      this.view = opts.view;
    }
    if (opts.filter) {
      this.filter = opts.filter;
    }
    if (opts.sort) {
      this.sort = opts.sort;
    }
    if (opts.limit !== null && opts.limit !== undefined) {
      this.limit = opts.limit;
    }
    if (opts.offset !== null && opts.offset !== undefined) {
      this.offset = opts.offset;
    }

    this.load = () => {
      this.changedItems.clear();
      this.status = "LOADING";
      if (this.filter) {
        this.handleLoadingPromise(getCubaREST()!.searchEntitiesWithCount(this.entityName, this.filter, this.loadOptions()));
      } else {
        this.handleLoadingPromise(getCubaREST()!.loadEntitiesWithCount(this.entityName, this.loadOptions()));
      }
    };

  }

  loadOptions = () => {
    const loadOptions = {
      view: this.view,
    };
    if (this.sort) {
      loadOptions['sort'] = this.sort;
    }
    if (this.limit !== null && this.limit !== undefined) {
      loadOptions["limit"] = this.limit;
    }
    if (this.offset !== null && this.offset !== undefined) {
      loadOptions['offset'] = this.offset;
    }
    return loadOptions;
  }

  handleLoadingPromise = (promise: Promise<EntitiesWithCount<T>>) => {
    promise
      .then((resp) => {
        runInAction(() => {
          this.items = this.afterLoadFilter(resp.result);
          this.count = resp.count;
          this.status = 'DONE';
        });
      })
      .catch(() => {
        runInAction(() => {
          this.status = 'ERROR';
        });
      });
  }
}

export function collectionWithAfterLoadFilter<T>(entityName: string, afterLoadFilter:
  (result: Array<SerializedEntity<T>>) => Array<SerializedEntity<T>>, opts?: DataCollectionOptions):
  DataCollectionStoreWithAfterLoadFilter<T> {
  if (!opts) opts = {
    loadImmediately: true
  };
  const dataCollection = new DataCollectionStoreWithAfterLoadFilter<T>(entityName, afterLoadFilter, opts);
  if (typeof opts.loadImmediately === 'undefined' || opts.loadImmediately) {
    dataCollection.load();
  }
  return dataCollection;
}